module.exports = __webpack_public_path__ + "img/logo_u1992-16.a927297c.svg";